import React, { useEffect, useState, useRef } from 'react';
interface AudioKnobProps {
  name: string;
  value: number;
  onChange: (value: number) => void;
}
const AudioKnob: React.FC<AudioKnobProps> = ({
  name,
  value,
  onChange
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const knobRef = useRef<HTMLDivElement>(null);
  // Calculate rotation based on value (0-100)
  const rotation = value / 100 * 270 - 135; // -135 to +135 degrees
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging || !knobRef.current) return;
      const knobRect = knobRef.current.getBoundingClientRect();
      const knobCenterX = knobRect.left + knobRect.width / 2;
      const knobCenterY = knobRect.top + knobRect.height / 2;
      // Calculate angle based on mouse position relative to knob center
      const angle = Math.atan2(e.clientY - knobCenterY, e.clientX - knobCenterX);
      let degrees = angle * (180 / Math.PI) + 90; // Convert to degrees and adjust
      // Limit the rotation to -135 to +135 degrees
      if (degrees > 180) degrees -= 360;
      degrees = Math.max(-135, Math.min(135, degrees));
      // Convert degrees to value (0-100)
      const newValue = Math.round((degrees + 135) / 270 * 100);
      onChange(newValue);
    };
    const handleMouseUp = () => {
      setIsDragging(false);
    };
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleMouseMove as any);
      document.addEventListener('touchend', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleMouseMove as any);
      document.removeEventListener('touchend', handleMouseUp);
    };
  }, [isDragging, onChange]);
  return <div className="flex flex-col items-center" data-id="element-2">
      <div ref={knobRef} className="w-20 h-20 bg-gradient-to-br from-gray-700 to-gray-900 rounded-full relative cursor-pointer shadow-lg border-2 border-gray-600" onMouseDown={() => setIsDragging(true)} onTouchStart={() => setIsDragging(true)} data-id="element-3">
        <div className="absolute w-1 h-8 bg-blue-400 rounded-full top-2 left-1/2 transform -translate-x-1/2 origin-bottom" style={{
        transform: `translateX(-50%) rotate(${rotation}deg)`
      }} data-id="element-4"></div>
        <div className="absolute inset-0 rounded-full border-4 border-gray-700" data-id="element-5"></div>
      </div>
      <div className="mt-2 text-center" data-id="element-6">
        <div className="text-sm text-gray-300" data-id="element-7">{name}</div>
        <div className="text-sm font-medium" data-id="element-8">{value}%</div>
      </div>
    </div>;
};
export default AudioKnob;